<template>
    <div class="sale">
        <el-form :model="searchData" :inline="true" size="small">
            <el-form-item v-if="searchData.type_id === 2">
                <el-select size="small" v-model="searchData.user_id" placeholder="销售员" clearable>
                    <el-option
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        v-for="item in userData.list"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchData.name" placeholder="客户名称/联系人" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-input v-model="searchData.contact_mobilephone" placeholder="手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-cascader
                    v-model="searchData.area"
                    :options="regionData.list"
                    filterable
                    clearable
                    :show-all-levels="false"
                ></el-cascader>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" @click="SearchCustomer">搜索</el-button>
            </el-form-item>
        </el-form>
        <div class="card">
            <div v-loading="customerData.loading.list" class="list">
                <el-row class="list-control">
                    <el-col :span="12">
                        <el-radio-group size="small" v-model="searchData.type_id" @change="SearchCustomer">
                            <el-radio-button :label="1">我的客户</el-radio-button>
                            <el-radio-button :label="2">全部客户</el-radio-button>
                        </el-radio-group>
                        <template v-if="searchData.type_id === 1">
                            <el-upload
                                action=""
                                :show-file-list="false"
                                :http-request="ImportCustomer"
                                class="list-upload"
                            >
                                <el-button size="small">导入客户</el-button>
                            </el-upload>
                        </template>
                    </el-col>
                    <el-col :span="12" class="t-right">
                        <template v-if="searchData.type_id === 1">
                            <template
                                v-if="
                                    [
                                        17,
                                        21,
                                        22,
                                        25,
                                        28,
                                        29,
                                        30,
                                        32,
                                        33,
                                        34,
                                        35,
                                        35,
                                        37,
                                        38,
                                        39,
                                        40,
                                        41,
                                        42,
                                        43,
                                        44,
                                        45,
                                        46,
                                        47
                                    ].indexOf($store.state.userInfo.id) < 0
                                "
                            >
                                <el-button
                                    size="small"
                                    :disabled="!componentParam.customerTransfer.customers.length"
                                    @click="transferCustomer"
                                    >转移</el-button
                                >
                            </template>
                            <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="DetailCustomer"
                                >客户</el-button
                            >
                        </template>
                    </el-col>
                </el-row>
                <el-alert
                    :title="'已选中 ' + componentParam.customerTransfer.customers.length + ' 名客户'"
                    type="info"
                    class="list-alert"
                    v-if="searchData.type_id === 1"
                ></el-alert>
                <div class="list-table">
                    <el-table
                        ref="customerTable"
                        :data="customerData.list"
                        stripe
                        style="width: 100%"
                        reserve-selection
                        @selection-change="SelectionCustomer"
                        @sort-change="SearchCustomer"
                    >
                        <template v-if="searchData.type_id === 1">
                            <el-table-column type="selection" width="50"></el-table-column>
                        </template>
                        <el-table-column label="名称" width="240">
                            <template slot-scope="scope">
                                <el-link type="primary" :underline="false" @click="DetailCustomer(scope.row)"
                                    >{{ scope.row.contact_name
                                    }}{{
                                        scope.row.name === scope.row.contact_name ? null : '（' + scope.row.name + '）'
                                    }}</el-link
                                >
                            </template>
                        </el-table-column>
                        <el-table-column label="地区">
                            <template slot-scope="scope"
                                >{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.county }}</template
                            >
                        </el-table-column>
                        <el-table-column label="创建时间" prop="created_at" sortable width="120">
                            <template slot-scope="scope">{{ scope.row.created_at | $moment('YYYY-MM-DD') }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" prop="updated_at" sortable width="120">
                            <template slot-scope="scope">{{ scope.row.updated_at | $moment('YYYY-MM-DD') }}</template>
                        </el-table-column>
                        <el-table-column label="跟进时间" prop="last_follow_time" sortable width="120">
                            <template slot-scope="scope">{{
                                scope.row.last_follow_time | $moment('YYYY-MM-DD')
                            }}</template>
                        </el-table-column>
                        <el-table-column label="下单时间" prop="last_order_time" sortable width="120">
                            <template slot-scope="scope">{{
                                scope.row.last_order_time | $moment('YYYY-MM-DD')
                            }}</template>
                        </el-table-column>
                        <el-table-column width="60">
                            <template slot-scope="scope">
                                <div class="t-right">
                                    <el-link type="primary" :underline="false" @click="GetCall(scope.row)"
                                        >呼叫</el-link
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="customerData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="customerData.pages.pagesize"
                        :total="customerData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-CustomerTransfer
            :detailParam="componentParam.customerTransfer"
            v-if="componentParam.customerTransfer.visible"
        />
        <v-CustomerDetail :detailParam="componentParam.customerDetail" v-if="componentParam.customerDetail.visible" />
        <v-CustomerForm :detailParam="componentParam.customerForm" v-if="componentParam.customerForm.visible" />
        <v-FollowForm :detailParam="componentParam.followForm" v-if="componentParam.followForm.visible" />
        <v-VisitForm :detailParam="componentParam.visitForm" v-if="componentParam.visitForm.visible" />
        <v-OrderForm :detailParam="componentParam.orderForm" v-if="componentParam.orderForm.visible" />
        <v-CooperationForm
            :detailParam="componentParam.cooperationForm"
            v-if="componentParam.cooperationForm.visible"
        />
    </div>
</template>

<script>
import { AreaData } from '@/plugin/Area'
import { UserData } from '@/plugin/User'
import CustomerTransfer from '@/components/customer/Transfer'
import CustomerDetail from '@/components/customer/Detail'
import CustomerForm from '@/components/customer/Form'
import FollowForm from '@/components/follow/Form'
import VisitForm from '@/components/visit/Form'
import OrderForm from '@/components/order/Form'
import CooperationForm from '@/components/cooperation/Form'
export default {
    components: {
        'v-CustomerTransfer': CustomerTransfer,
        'v-CustomerDetail': CustomerDetail,
        'v-CustomerForm': CustomerForm,
        'v-FollowForm': FollowForm,
        'v-VisitForm': VisitForm,
        'v-OrderForm': OrderForm,
        'v-CooperationForm': CooperationForm
    },
    inject: ['reload'],
    mixins: [AreaData, UserData],
    data() {
        return {
            userData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            searchData: {
                type_id: 1,
                user_id: null,
                name: null,
                contact_mobilephone: null,
                area: [],
                province: null,
                city: null,
                county: null,
                order_field: 'id',
                order: 'desc'
            },
            customerData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentParam: {
                customerTransfer: {
                    visible: false,
                    customers: []
                },
                customerDetail: {},
                customerForm: {},
                followForm: {},
                visitForm: {},
                orderForm: {},
                cooperationForm: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetCustomer()
        })
    },
    watch: {
        'searchData.type_id'(val) {
            this.searchData.user_id = null
            if (val === 2 && !this.userData.list.length) {
                this.GetUser()
            }
        }
    },
    methods: {
        // 员工
        GetUser() {
            this.GetUserData({
                data: {
                    order: 'asc',
                    ...this.userData.pages
                }
            }).then(res => {
                this.userData.list = res.list
            })
        },
        // 查询
        SearchCustomer(column) {
            if (column.order) {
                this.searchData.order_field = column.prop
                this.searchData.order = column.order === 'ascending' ? 'asc' : 'desc'
            } else {
                this.searchData.order_field = 'id'
                this.searchData.order = 'desc'
                this.$refs.customerTable.clearSort()
            }
            this.customerData.pages.page = 1
            if (this.searchData.area.length) {
                this.searchData.province = this.searchData.area[0]
                this.searchData.city = this.searchData.area[1]
                this.searchData.county = this.searchData.area[2]
            }
            this.GetCustomer()
        },
        GetCustomer() {
            this.customerData.loading.list = true
            this.$request({
                url: '/api/v1/customer_user',
                params: {
                    ...this.searchData,
                    ...this.customerData.pages
                }
            }).then(res => {
                this.customerData.loading.list = false
                if (!res.status) {
                    this.customerData.list = res.data.list
                    this.customerData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.customerData.pages.pagesize = val
            this.GetCustomer()
        },
        GetCurrent(val) {
            this.customerData.pages.page = val
            this.GetCustomer()
        },
        // 导入
        ImportCustomer(obj) {
            var requestData = new FormData()
            requestData.append('report', obj.file)
            requestData.append('user_id', this.$store.state.userInfo.id)
            this.$request({
                url: '/api/v1/customer_import',
                method: 'POST',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: requestData
            }).then(res => {
                this.$message({
                    message: res.data || (res.status ? '操作失败' : '操作成功'),
                    type: res.status ? 'error' : 'success'
                })
                if (!res.status) {
                    this.reload()
                }
            })
        },
        // 多选
        SelectionCustomer(val) {
            this.componentParam.customerTransfer.customers = []
            val.forEach(row => {
                this.componentParam.customerTransfer.customers.push(row.customer_id)
            })
        },
        // 转移
        transferCustomer() {
            this.componentParam.customerTransfer.visible = true
        },
        // 客户详情 增加&修改
        DetailCustomer(row) {
            if (row.id) {
                this.componentParam.customerDetail = {
                    visible: true,
                    row: {
                        customer_id: row.id
                    }
                }
            } else {
                this.componentParam.customerForm = {
                    visible: true,
                    row: {
                        customer_sea_id: this.searchData.id
                    }
                }
            }
        },
        // 呼叫
        GetCall(row) {
            this.$confirm('请稍候，我们将马上接通您的电话, 请注意接听！', '进行呼叫？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/getsign',
                        params: {
                            passiveNum: row.contact_mobilephone
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.message ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/card.less';
@import '~@/assets/css/list.less';
</style>
